<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">위탁안내</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section">
                    <div class="mb-20 mb-md-40">
                        <h2 class="tit">위탁 절차</h2>
                    </div>
                    <div class="my-n10 my-md-0">
                        <v-row no-gutters>
                            <v-col cols="6" md="3">
                                <div class="py-10 py-md-0">
                                    <div class="mb-14 mb-md-24" style="height:58px;">
                                        <v-img contain width="56" height="56" src="/images/sub/how-to/how-to-consignment-icon.png"></v-img>
                                    </div>
                                    <div>
                                        <v-divider class="primary v-divider--dot my-16"></v-divider>
                                        <p class="font-size-14 font-size-md-16 font-weight-bold primary--text mb-4">STEP 1</p>
                                        <h5 class="tit tit--xs font-weight-regular">위탁신청 접수</h5>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6" md="3">
                                <div class="py-10 py-md-0">
                                    <div class="mb-14 mb-md-24" style="height:58px;">
                                        <v-img contain width="56" height="56" src="/images/sub/how-to/how-to-consignment-icon2.png"></v-img>
                                    </div>
                                    <div>
                                        <v-divider class="primary v-divider--dot my-16"></v-divider>
                                        <p class="font-size-14 font-size-md-16 font-weight-bold primary--text mb-4">STEP 2</p>
                                        <h5 class="tit tit--xs font-weight-regular">심의 및 감정</h5>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6" md="3">
                                <div class="py-10 py-md-0">
                                    <div class="mb-14 mb-md-24" style="height:58px;">
                                        <v-img contain width="58" height="58" src="/images/sub/how-to/how-to-consignment-icon3.png"></v-img>
                                    </div>
                                    <div>
                                        <v-divider class="primary v-divider--dot my-16"></v-divider>
                                        <p class="font-size-14 font-size-md-16 font-weight-bold primary--text mb-4">STEP 3</p>
                                        <h5 class="tit tit--xs font-weight-regular">위탁계약 체결 및 출품</h5>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6" md="3">
                                <div class="py-10 py-md-0">
                                    <div class="mb-14 mb-md-24" style="height:58px;">
                                        <v-img contain width="56" height="56" src="/images/sub/how-to/how-to-consignment-icon4.png"></v-img>
                                    </div>
                                    <div>
                                        <v-divider class="primary v-divider--dot my-16"></v-divider>
                                        <p class="font-size-14 font-size-md-16 font-weight-bold primary--text mb-4">STEP 4</p>
                                        <h5 class="tit tit--xs font-weight-regular">경매결과 통보 및 대금정산</h5>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="3">
                                <h2 class="tit">위탁신청 접수</h2>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <div>
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">이메일 접수</h4>
                                    </div>
                                    <div>
                                        <p class="page-text">작품에 대한 상세한 정보와 이미지를 이메일로 보내주시면 개별 답변을 드립니다.</p>
                                        <p class="page-text primary--text">kata-auction@naver.com</p>
                                    </div>
                                    <div class="mt-10 mt-md-14">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-card tile outlined class="h-100">
                                                    <div class="pa-16 px-md-30 py-md-20">
                                                        <p class="page-text primary--text">메일 제목 : 작품위탁_고객님 성함</p>
                                                    </div>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="mt-n1">
                                                <v-card tile outlined class="h-100">
                                                    <div class="pa-16 px-md-30 py-md-20">
                                                        <div class="mb-10">
                                                            <p class="page-text primary--text">메일 내용</p>
                                                        </div>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <div class="page-text">
                                                                    <p>1. 고객님 성함</p>
                                                                    <p>2. 연락처</p>
                                                                    <p>3. 작품정보 (작가명/작품명/제작연도/크기/재질)</p>
                                                                </div>
                                                            </v-col>
                                                            <v-col cols="12" md="6" class="mt-n16 mt-md-0">
                                                                <div class="page-text">
                                                                    <p>4. 소장경위</p>
                                                                    <p>5. 작품사진<br/>(전체 이미지, 서명 등 중요부분 이미지)</p>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">홈페이지 접수</h4>
                                    </div>
                                    <div>
                                        <p class="page-text">작가의 작품위탁: 작가의 작품위탁은 갤러리를 통하여 접수받고 있습니다. 갤러리에 포트폴리오를 제출하십시오.</p>
                                    </div>
                                    <div class="mt-10 mt-md-14">
                                        <ul class="letter-list">
                                            <li><em>-</em><span>회원가입/로그인 후 이용 가능합니다.</span></li>
                                            <li>
                                                <em>-</em>
                                                <span>
                                                    입력해주신 연락처로 개별 답변을 드립니다.
                                                    <div class="mt-4">
                                                        <v-btn small text height="auto" color="grey-68" to="/form/consignment-sale" class="pa-0 v-btn--none-active-bg"><strong>위탁 신청 하기</strong><v-icon>mdi-menu-right</v-icon></v-btn>
                                                    </div>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">우편접수</h4>
                                    </div>
                                    <div>
                                        <p class="page-text primary--text">(우) 03021 서울 종로구 부암동 185-6, 캐터옥션 경매담당자앞 </p>
                                    </div>
                                    <div class="mt-10 mt-md-14">
                                        <p class="page-text">보내실 내용은 위의 이메일 접수 내용과 동일합니다. 봉투에 ‘위탁신청’이라고 표기해 주십시오.<br/>우편으로 접수된 사진은 반송되지 않습니다.</p>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="primary"></v-divider>

                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="3">
                                <h2 class="tit">심의 및 감정</h2>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <div>
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">서면 심의</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">1. 심의 항목</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text" style="letter-spacing:-.04em!important;">작품성, 작품상태, 판매가능성, 작품가치, 판매대상 범위와의 부합성 등 다양한 측면을 고려하여 서면심의를 진행합니다</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">2. 심의 기간</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">접수일로부터 7일 이내 심의를 완료합니다</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">3. 심의 결과 안내</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">위탁신청 접수 내용을 토대로 심의 후, 위탁 가능 여부를 위탁자에게 개별 안내해 드립니다</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">실물 감정</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">1. 작품 운송</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">서면심의를 거친 작품에 한해, 실물을 캐터옥션에 입고합니다 (위탁자가 운송)</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">2. 실물 감정</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <ul class="letter-list">
                                                        <li><em>-</em><span>당사에 입고된 작품을 전문가를 통해 실물감정 후 최종으로 출품여부를 결정합니다.</span></li>
                                                        <li><em>-</em><span>캐터옥션은 작품의 새로운 가치를 발굴하고자 노력합니다.</span></li>
                                                        <li><em>-</em><span>경매 불가 작품은 의뢰인에게 다시 보내 드립니다. (운송비 의뢰인 부담, 방문 회수 시 제외)</span></li>
                                                    </ul>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">3. 출품가 결정<br/>(가격 감정)</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <ul class="letter-list">
                                                        <li><em>-</em><span>실물 감정을 통과한 작품에 한해 위탁자와 담당자 간의 출품가( 내정가 )를 결정합니다.</span></li>
                                                        <li><em>-</em><span>출품가는 작품이 진품이며, 자유롭게 판매될 수 있음을 전제로 산출합니다.</span></li>
                                                        <li><em>-</em><span>작품의 내정가는 의뢰자와 합의 하에 결정되며, 합의가 되지 않을 경우 출품되지 않습니다.</span></li>
                                                    </ul>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="primary"></v-divider>

                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="3">
                                <h2 class="tit">위탁계약 체결 및 <br class="d-none d-md-block"/>출품</h2>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <div>
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">위탁 계약 체결</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">1. 계약 체결</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">출품가격 결정 후 위탁계약서를 작성합니다</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">2. 출품 시기</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">출품 시기를 확정하여 출품 전 위탁자에게 출품 확인합니다</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">전시 출품</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <p class="page-text">전시 출품 위탁계약 완료 후, 캐터옥션의 책임과 비용으로 출품작을 전시합니다. </p>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">1. 오프라인 전시</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">갤러리 라온 (서울시 종로구 부암동 185-6)</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">2. 온라인 전시</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">캐터옥션 홈페이지</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">판촉 활동</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">1. 판촉 기간</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">경매 프리뷰 기간 동안에, 해당 옥션에 대한 적극적인 판촉활동을 전개하여, 작품판매를 촉진합니다.</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-6 mt-md-10">
                                            <v-row no-gutters>
                                                <v-col cols="12" md="2">
                                                    <p class="page-text">2. 판촉 채널</p>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text">언론보도, 유튜브, 인스타, 네이버(광고), 다음(광고), 블로그 등 다양한 홍보채널을 활용합니다.</p>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="primary"></v-divider>

                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="3">
                                <h2 class="tit">경매결과 통보 및 <br class="d-none d-md-block"/>대금정산</h2>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <div>
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">경매결과 통보</h4>
                                    </div>
                                    <div>
                                        <div>
                                            <div class="page-text">
                                                <p class="font-weight-medium primary--text">경매결과 통보</p>
                                                <p>낙찰자 : 경매 종료 후, 낙찰자에게 &lt;낙찰통보서&gt;를 이메일로 발송합니다.</p>
                                                <p>위탁자 : 경매 종료 후, 위탁자에게 &lt;경매 결과 안내서&gt;를 이메일로 발송합니다.</p>
                                                <p>※ 낙찰된 작품에는 소정의 위탁수수료가 부과</p>
                                            </div>
                                        </div>
                                        <div class="mt-14 mt-md-20">
                                            <div class="page-text">
                                                <p class="font-weight-medium primary--text">낙찰대금 납부</p>
                                                <p>3억 미만 : 낙찰 후 1주일 이내에 낙찰대금 완납</p>
                                                <p>3억 이상 : 낙찰 후 1주일 이내에 50%, 3주 이내에 완납</p>
                                                <p>작품인도 : 낙찰대금 완납 후 낙찰자에게 작품 인도</p>
                                            </div>
                                        </div>
                                        <div class="mt-14 mt-md-20">
                                            <div class="page-text">
                                                <p class="font-weight-medium primary--text">위탁대금 지급</p>
                                                <p>지급시기 : 낙찰자의 낙찰대금이 완납되면, 위탁자에게는 위탁대금을 지급합니다<br/>(통상 3억 미만은 1주일 이내, 3억 이상은 3주일 이내 지급 예상)</p>
                                                <p>※ 위탁대금 = 낙찰금액 - 위탁수수료(5%, VAT별도) - 기타 비용(발생할 경우)</p>
                                                <p>※ 기타비용 : 보험가입, 액자교체, 보존처리, 전문감정 등 고객 요청으로 인해 발생한 비용</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-18 mt-md-30">
                                    <div class="mb-10">
                                        <h4 class="tit tit--xs">위탁 수수료</h4>
                                    </div>
                                    <div>
                                        <div class="page-text">
                                            <p>위탁 수수료 : 낙찰가의 5% (부가세 별도)를 적용합니다.</p>
                                            <p>양도세 부과 : 양도가액 6,000만원 이상인 것을 대상으로 합니다. 양도일 현재 생존해 있는 국내 작가의 작품은 제외됩니다.</p>
                                            <p>유찰된 작품 : 위탁자가 반출하셔야 합니다 (운송은 위탁자가 진행) </p>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
</style>